import { Icon } from '@iconify/react'
import { campaignSalesClosedReason, type CampaignSalesWindow } from '@/lib/campaign-sales'
import styles from './LandingSalesClosedNotice.module.css'

type LandingSalesClosedNoticeProps = {
  campaign: CampaignSalesWindow
  visualVariant?: 'light' | 'dark'
}

export function LandingSalesClosedNotice({
  campaign,
  visualVariant = 'light',
}: LandingSalesClosedNoticeProps) {
  const reason = campaignSalesClosedReason(campaign)
  const rootClass = visualVariant === 'dark' ? `${styles.notice} ${styles.noticeDark}` : styles.notice

  return (
    <div className={rootClass} role="status">
      <Icon icon="mdi:calendar-remove-outline" className={styles.icon} aria-hidden />
      <p className={styles.text}>{reason}</p>
    </div>
  )
}
